import { SanitizedHtml } from '../components/SanitizedHtml';
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { talentyApi, type FamilyLandingPageResponse } from '../services/talentyApi';

const FamilyDetailPage: React.FC = () => {
  const { family } = useParams<{ family: string }>();
  const [familyPage, setFamilyPage] = useState<FamilyLandingPageResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFamilyPage = async () => {
      if (!family) {
        setError('Es wurde keine Jobfamilie angegeben.');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        // Use slug-based endpoint (family param is now the slug)
        const response = await talentyApi.getFamilyLandingPageBySlug(family);
        setFamilyPage(response);
      } catch (err) {
        console.error('Jobfamilienseite konnte nicht geladen werden:', err);
        setError('Die Jobfamilienseite konnte nicht geladen werden.');
      } finally {
        setLoading(false);
      }
    };

    fetchFamilyPage();
  }, [family]);


  // Set document title and meta description when family page loads
  useEffect(() => {
    if (familyPage) {
      document.title = familyPage.title;
      
      // Update meta description
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', familyPage.metaDescription);
      } else {
        const meta = document.createElement('meta');
        meta.name = 'description';
        meta.content = familyPage.metaDescription;
        document.head.appendChild(meta);
      }

      // Update meta keywords
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', familyPage.keywords.join(', '));
      } else {
        const meta = document.createElement('meta');
        meta.name = 'keywords';
        meta.content = familyPage.keywords.join(', ');
        document.head.appendChild(meta);
      }
    }
  }, [familyPage]);

  if (loading) {
    return (
      <div className="job-detail-page">
        <div className="container">
          <div className="loading">Lade Familie...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="job-detail-page">
        <div className="container">
          <div className="error">
            <h2>Familie nicht gefunden</h2>
            <p>{error}</p>
            <Link to="/domains" className="btn btn-primary">
              Zurück zu allen Bereichen
            </Link>
          </div>
        </div>
      </div>
    );
  }

  if (!familyPage) {
    return (
      <div className="job-detail-page">
        <div className="container">
          <div className="error">
            <h2>Familie nicht verfügbar</h2>
            <Link to="/domains" className="btn btn-primary">
              Zurück zu allen Bereichen
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="job-detail-page">
      <div className="breadcrumb">
        <div className="container">
          <Link to="/domains" className="breadcrumb-link">Alle Bereiche</Link>
          <span className="breadcrumb-separator">›</span>
          <span className="breadcrumb-current">{familyPage.title}</span>
        </div>
      </div>
      
      <div className="job-content">
        {/* Render the generated HTML from Talenty */}
        <SanitizedHtml className="generated-content" content={familyPage.html} format="generated" />
      </div>
    </div>
  );
};

export default FamilyDetailPage;
